export default "__VITE_ASSET__BDR0aTyf__"